import Vue from "vue";
import Vuex from "vuex";
import buildConfig from "@/utils/config";
import plugins from "@/utils/plugins";

Vue.use(Vuex);

export default function(http, identity, get_user_info) {
  const tokenKey = identity + "Token",
    schoolKey = identity + "School",
    breadKey = identity + "Breads";
  return new Vuex.Store({
    state: {
      webConfig: {},
      token: localStorage[tokenKey] || "",
      user_info: {},
      school_info: {
        list: [], // 校区列表
        cur_school_id: 0, // 当前校区id
        cur_district_name: "", // 当前地区名称
        cur_school_name: "", // 当前校区名称
      },
      keywords: "",
      commonSetting: {
        point_info: {},
        course_name: {},
      },
      showLoginModal: false,
      liveSelect: {
        show: false,
        client_url: "",
        web_url: "",
        title: "",
      },
      breads: sessionStorage[breadKey]
        ? JSON.parse(sessionStorage[breadKey])
        : [],
      search: "",
      svg: ``,
      template: "rich",
      navigates: [],
      message: {
        all: {},
        course: {},
        order: {},
        system: {},
        oto: {},
        exam: {},
      },
      homeworkTab: "",
      homeworkState: {},
      showLoading: false,
      formulaDlg: {
        show: false,
        uid: 0,
        selectionIndex: 0,
      },
      keepAlivesFixed: [], // 固定 keepAlive
      keepAlivesDynamic: [], // 动态 keepAlive,
      memberLeftHeight: 0,
    },
    getters: {
      // 校区数量
      schoolCount: state => {
        let ret = 0;
        state.school_info.list.forEach(province => {
          province.city &&
            province.city.forEach(city => {
              if (city.schools.length) {
                ret += city.schools.length;
              }
            });
        });
        return ret;
      },
    },
    mutations: {
      setHomeworkTab(state, tab) {
        state.homeworkTab = tab;
      },
      setWebConfig(state, config) {
        state.webConfig = config;
      },
      setCommonSetting(state, setting) {
        state.commonSetting = setting;
      },
      login(state, token) {
        state.token = token;
        localStorage[tokenKey] = token;
      },
      setUser(state, info) {
        state.user_info = info;
      },
      logout(state) {
        state.token = "";
        state.user_info = {};
        localStorage.removeItem(tokenKey);
        // 这里不清空校区数据
      },
      setSchoolInfo(state, info) {
        state.school_info = info;
        this.commit("setSchoolID", info.cur_school_id);
      },
      clearSchoolInfo(state) {
        state.school_info = {
          list: [], // 校区列表
          cur_school_id: 0, // 当前校区id
          cur_district_name: "", // 当前地区名称
          cur_school_name: "", // 当前校区名称
        };
        this.commit("clearShoolID");
      },
      setSchoolID(state, school_id) {
        localStorage[schoolKey] = school_id || "";
      },
      clearShoolID() {
        localStorage.removeItem(schoolKey);
      },
      search(state, keywords) {
        state.keywords = keywords;
      },
      setMessage(state, message) {
        state.message = message;
      },
      showLogin(state, flag) {
        state.showLoginModal = flag;
      },
      showSelectLive(state, liveSelect) {
        state.liveSelect = liveSelect;
      },
      setBreads(state, route) {
        const bread = {
          title: route.meta.title,
          name: route.name,
          routeName: route.name,
          query: route.query,
          params: route.params,
        };
        if (route.meta.root) {
          state.breads = [bread];
        } else {
          // 如果在面包屑链中，直接跳至该面包屑
          let existBread = false;
          for (let i = 0; i < state.breads.length; ++i) {
            if (state.breads[i].name == bread.name) {
              existBread = true;
              state.breads.splice(i + 1);
              break;
            }
          }
          if (!existBread) {
            state.breads.push(bread);
          }
        }
        sessionStorage[breadKey] = JSON.stringify(state.breads);
      },
      setKeepAlive(state, ary) {
        if (ary) {
          state.keepAlivesDynamic = ary;
        } else {
          let tmpAry = [];
          state.breads.forEach(i => {
            tmpAry.push(i.name);
          });
          state.keepAlivesDynamic = tmpAry;
        }
      },
      addKeepAlive(state, name) {
        !state.keepAlivesDynamic.includes(name) &&
          state.keepAlivesDynamic.push(name);
      },
      setSearch(state, search) {
        state.search = search;
      },
      setSvg(state, svg) {
        if (!svg) {
          return;
        }
        let tempDiv = document.createElement("div");
        tempDiv.innerHTML = svg;
        let elements = tempDiv.querySelectorAll("path,g");
        elements.forEach(ele => {
          ele.removeAttribute("fill");
        });
        elements = tempDiv.querySelectorAll("svg");
        elements.forEach(ele => {
          ele.removeAttribute("width");
          ele.removeAttribute("height");
        });
        state.svg = tempDiv.innerHTML;
      },
      setNavigates(state, navigates) {
        state.navigates = navigates;
      },
      setMessageRead(state, { type }) {
        state.message[type].not_read--;
        state.message[type].not_read_show =
          state.message[type].not_read < 100
            ? state.message[type].not_read
            : "99+";
        state.message.all.not_read--;
        state.message.all.not_read_show =
          state.message.all.not_read < 100 ? state.message.all.not_read : "99+";
      },
      setAllMessageRead(state) {
        for (let key in state.message) {
          state.message[key].not_read = 0;
          state.message[key].not_read_show = 0;
        }
      },
      setHomeworkState(state, hw) {
        state.homeworkState = hw;
      },
      setLoading(state, show) {
        state.showLoading = show;
      },
      setMemberLeftHeight(state, height) {
        state.memberLeftHeight = height;
      },
    },
    actions: {
      async get_user_info(context) {
        await get_user_info(context);
      },
      async get_user_info_friend(context) {
        if (!context.state.token) {
          return;
        }
        let data = await http.get(
          "/api/app/userInfo",
          {},
          {
            onError: data => {
              if (data.code == 202) {
                context.commit("logout");
              }
            },
          }
        );
        data.sex = data.sex.toString();
        context.commit("setUser", data);
      },
      async getSchoolInfo({ commit }) {
        try {
          const datas = await http.get(
            "/api/app/getSchool",
            {},
            {
              allowReject: true,
            }
          );
          const schoolID = localStorage[schoolKey];
          // console.log(datas, schoolID);
          let curSchool = _findSchool(datas, schoolID);
          if (!curSchool) return;
          // if (!curSchool) {
          //   curSchool = _findSchool(datas);
          // }
          commit("setSchoolInfo", {
            list: datas,
            cur_school_id: curSchool.school_id,
            cur_district_name: curSchool.district_name,
            cur_school_name: curSchool.school_name,
          });
        } catch (e) {
          //
        }
      },
      async getWebConfig({ commit }, title) {
        try {
          let config = (await http.get(
            "/api/app/config/system_webConfig",
            {},
            {
              allowReject: true,
            }
          )).system_webConfig;
          commit("setWebConfig", config);
          document.title = config.web_title + title;

          let setting = await buildConfig(http);
          commit("setCommonSetting", setting);
          commit("setSvg", setting.ios_price_icon);

          let link =
            document.querySelector("link[rel*='icon']") ||
            document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = config.web_ico;
          document.getElementsByTagName("head")[0].appendChild(link);

          plugins.appendJs(setting.customer_service_code);
        } catch (e) {
          console.log(e)
        }
      },
      async refreshMessageState(context) {
        let message = {
          all: {},
          course: {},
          order: {},
          system: {},
          oto: {},
          exam: {},
        };
        let not_read = 0;
        let list = await http.post(
          "/api/app/message/classifyMessage",
          {},
          {
            onError: data => {
              if (data.code == 202) {
                context.commit("logout");
              }
            },
          }
        );
        list.forEach(item => {
          not_read += item.not_read;
          message[item.message_classify] = {
            not_read: item.not_read,
            not_read_show: item.not_read < 100 ? item.not_read : "99+",
          };
        });
        message["all"] = {
          not_read,
          not_read_show: not_read < 100 ? not_read : "99+",
        };
        context.commit("setMessage", message);
      },
      async refreshHomeworkState(context) {
        let data = await http.get(
          "/api/app/user/homework/listNum",
          {},
          {
            onError: () => {},
          }
        );
        let state = {
          count: data.no_submit_num,
          count_show: data.no_submit_num < 100 ? data.no_submit_num : "99+",
        };
        context.commit("setHomeworkState", state);
      },
    },
  });
}

function _findSchool(provinces, schoolID) {
  if (provinces && provinces.length) {
    // 有 schoolID 则寻找，没有则拿第一个校区
    if (schoolID) {
      for (const province of provinces) {
        for (const city of province.city) {
          for (const school of city.schools) {
            if (school.school_id == schoolID) {
              return {
                school_id: school.school_id,
                district_name: school.district_name,
                school_name: school.school_name,
              };
            }
          }
        }
      }
    } else if (
      provinces[0].city.length &&
      provinces[0].city[0].schools.length
    ) {
      const school = provinces[0].city[0].schools[0];
      return {
        school_id: school.school_id,
        district_name: school.district_name,
        school_name: school.school_name,
      };
    }
  }
  return null;
}
